<template>
  <div class="d-flex flex-column m-3" :data-cy="dataCy">
    <study-web-upload
      v-if="shouldShowWebUploader"
      v-bind="{
        fileValidator,
        isDicomOnly,
        convertAttachments,
        anonymize,
        singlePatient,
        anonymizeSettings,
        generateRequiredMissingTags,
        append,
        dataCy,
      }"
      with-integrity-check
      @uploaded-attachments="$emit('uploaded-attachments', $event)"
      @uploaded="$emit('uploaded', $event)"
    />
    <research-upload-area-data-organism
      v-bind="{
        instanceId,
        repositoryUuid,
        readonly,
        moduleUuid,
        moduleSettings,
        module,
        isFromSegmentationModule,
        showSegmentationInstance,
        segmentationOptions,
        reviewButtonText,
        repository,
        project,
        subject,
        event,
      }"
      :segmentation="showSegmentationInstance"
      @segmentation="$emit('segmentation', $event)"
    />
  </div>
</template>

<script>
  export default {
    name: 'ResearchUploadAreaNew',

    props: {
      fileValidator: { type: Function, default: (/* item, ftype */) => true },
      anonymize: { type: Boolean, default: true },
      anonymizeSettings: {
        type: Object,
        default: () => ({}),
      },
      repositoryUuid: String,
      isDicomOnly: Boolean,
      convertAttachments: Boolean,
      instanceId: Number,
      moduleUuid: String,
      readonly: Boolean,
      singlePatient: { type: Boolean, default: true },
      generateRequiredMissingTags: { type: Boolean, default: false },
      dataCy: String,
      moduleSettings: Object,
      module: Object,
      append: Boolean,
      isFromSegmentationModule: Boolean,
      showSegmentationInstance: {
        type: Boolean,
        default: true,
      },
      showWebUploader: {
        type: Boolean,
        default: true,
      },
      segmentationOptions: [Object, null, undefined],
      reviewButtonText: {
        type: String,
        default: function () {
          return this.$t('cmrad.open_review_mode');
        },
      },
      repository: Object,
      project: Object,
      subject: Object,
      event: Object,
    },

    components: {
      ResearchUploadAreaDataOrganism: () => import('@/Organisms/ResearchModules/ResearchUploadAreaDataOrganism'),
      StudyWebUpload: () => import('@/Organisms/StudyWebUpload'),
    },

    computed: {
      shouldShowWebUploader() {
        return !this.readonly && this.showWebUploader;
      },
    },
  };
</script>
